import axios from "axios";

import { errorCatcher } from "utils/helpers/errorCatcher";

export const changeVisibility = (buildingId: number | string, action: "show" | "hide", itemsIds: number[]) => {
  return axios
    .post(`/building/${buildingId}/estimate/items/hide_show/`, { estimate_items: itemsIds, action })
    .catch(errorCatcher);
};
